import * as React from 'react';
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import { SystemTranslationKeys } from '@common/entities';

import { useSystemTranslation } from 'hooks';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  modalHeader: string;
  modalText: string;
  modalSize?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | '6xl' | 'full';
  modalBodyTextSize?:
    | 'xs'
    | 'sm'
    | 'md'
    | 'lg'
    | 'xl'
    | '2xl'
    | '3xl'
    | '4xl'
    | '5xl'
    | '6xl'
    | 'full';
  actionBtnText?: string;
  onClickAction?: () => void;
  actionBtnVariant?: 'success' | 'caution' | 'danger' | 'neutral' | 'brand' | 'action';
}
export function OkModal(props: Props) {
  const { tSystem } = useSystemTranslation();
  const {
    isOpen,
    onClose,
    modalHeader,
    modalText,
    modalSize = 'xs',
    modalBodyTextSize = 'md',
    actionBtnText,
    onClickAction,
    actionBtnVariant = 'brand',
  } = props;

  return (
    <Modal size={modalSize} isCentered isOpen={isOpen} onClose={onClose}>
      <ModalOverlay bg="black.200" backdropFilter="blur(12px) hue-rotate(0deg)" />
      <ModalContent bg="white.base" border="1px" borderColor="gray.light" borderRadius={8}>
        <ModalHeader>{modalHeader}</ModalHeader>
        <ModalBody px={6} py={8}>
          <Text textAlign="center" wordBreak="break-word" fontSize={modalBodyTextSize}>
            {modalText}
          </Text>
        </ModalBody>
        <ModalFooter borderBottomRightRadius={8} borderBottomLeftRadius={8} bg="silver.essence">
          <Button size="sm" onClick={onClose} mr={4}>
            {tSystem(SystemTranslationKeys.common.close)}
          </Button>
          {onClickAction && actionBtnText && (
            <Button size="sm" variant={actionBtnVariant} onClick={onClickAction}>
              {actionBtnText}
            </Button>
          )}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
